import { computed, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type {
  AttachedFile,
} from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/types'

export default defineStore('attachedFilesStore', () => {
  const attachedFiles = ref<AttachedFile[]>([])
  const lastFileId = ref(0)
  const attachedFileByteSizes = computed(() => attachedFiles.value.reduce((result, { file }) => result + file.size, 0))

  function createAttachedFile(file: File) {
    lastFileId.value++

    const attachedFile: AttachedFile = {
      file,
      id: lastFileId.value,
      isDeleted: false,
      status: 'loading',
      progress: null,
    }

    attachedFiles.value.push(attachedFile)

    return attachedFile
  }

  function deleteAttachedFile(attachedFile: AttachedFile) {
    attachedFile.isDeleted = true
    attachedFiles.value = attachedFiles.value.filter(i => i !== attachedFile)
  }

  const isErrorState = ref(false)

  function validate() {
    const isValid = attachedFiles.value.some(i => i.status === 'success')
    && attachedFiles.value.every(i => i.status !== 'loading')

    isErrorState.value = !isValid

    return isValid
  }

  watch(() => attachedFiles.value.length, () => {
    isErrorState.value = false
  })

  return {
    attachedFiles,
    attachedFileByteSizes,
    createAttachedFile,
    deleteAttachedFile,
    isErrorState,
    validate,
  }
})
